import React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import Dropzone from 'react-dropzone'
import { Icon } from 'semantic-ui-react'
import styled from '@emotion/styled'

import { toastError, toastWarning, showConfirmModal } from 'ducks/app'
import { FileUploadCell } from 'components'

import * as v from 'variables/styled'

export const DropzoneContainer = styled.div({
  marginTop: '10px',
  display: 'flex',

  '.inputContent': {
    display: 'flex',
    flex: 1,
    width: '100%',
  },

  '.dropArea': {
    cursor: 'pointer',
    display: 'flex',
    background: '#FFF',
    border: `dashed 1.5px ${v.borderGray}`,
    borderRadius: '5px',
    padding: '20px 0px',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    flex: 1,
    width: '100%',

    '.textTitle': {
      fontSize: '1.25rem',
      color: '#505050',

      svg: {
        fontSize: '1rem',

        path: {
          color: v.btnGray,
        },
      },
    },

    '.buttonUI': {
      height: '35px',
      background: v.bgSoftGray,
      borderRadius: '5px',
      fontSize: '1.25rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '200px',
      color: '#505050',
    },
  },

  '.dropArea.error': {
    backgroundColor: '#fff6f6',
    borderColor: '#e0b4b4',
  },
})

const FileInput = (props) => {
  const {
    label, 
    docCode, 
    oldFiles=[], 
    change, 
    removeOldFiles, 
    showOldFile,
    removeFiles, 
    fieldInputStyle = {}, 
    require, 
    input, 
    duplicateCheck, 
    style, 
    limitFileSize = 250, 
    limitFileItem = -1, 
    multipleSelect = true,
    replaceUpload, 
    clearFiles, 
    editable = true,
    acceptFileType='.xlsx,.xls,image/*,.doc,.docx,.ppt,.pptx,.txt,.pdf,.zip,.rar,.7z,.msg',
    meta: { touched, error } 
  } = props

  const findLastIndex = () =>{
    let count = oldFiles.length
    let index =-1;
    for(let i = (count-1);i>=0;i--){
      let temp = oldFiles[i]
      if(!temp.deleted && temp.documentCode.toLowerCase()==input.name.toLowerCase()){
        index = i
        break;
      }
    }
    return index
  }


  return (
    <div className='fieldRow' style={{ ...style }}>
      <span className='fieldLabel'>
        {label}
        {require ? <span className='require'>*</span> : null}
        {touched && error ? <span className='error'>{error}</span> : null}
      </span>
      <div className='fieldInput' style={{ ...fieldInputStyle }}>
        {editable?
        <Dropzone
          name={input.fileName}
          accept={acceptFileType}
          multiple={multipleSelect}
          onDrop={
            acceptedFiles => {
              const checkCaseLimitFileItem = (currentInput,file)=>{
                if(oldFiles){//case has old file
                  let countOldFile = oldFiles.filter(x=>!x.deleted && x.documentCode.toLowerCase()==input.name.toLowerCase()).length
                  if(countOldFile==limitFileItem){//case no new file but old file equre limitFileItem
                    //get last index to delete file
                    let lastIndex = findLastIndex()
                    change(`attachments[${lastIndex}].deleted`, true)
                    input.onChange([...currentInput, file])
                  }else if((currentInput.length+countOldFile)==limitFileItem){//case newFile + oldFile equre limitfileItem
                    currentInput.splice((currentInput.length-1), 1)
                    input.onChange([...currentInput, file])
                  }else{
                    input.onChange([...currentInput, file])
                  }
                }else{//case no old file
                  if(currentInput.length<limitFileItem){
                    input.onChange([...currentInput, file])
                  }else{
                    //replace last file
                    currentInput.splice((currentInput.length-1), 1)
                    input.onChange([...currentInput, file])
                  }
                }
              }
              acceptedFiles.forEach(file => {
                const reader = new FileReader()
                let currentInput = input.value||[]
                reader.onload = () => {
                  if ((file.size / (1024 * 1024)).toFixed(2) > limitFileSize) { //filter file size
                    props.toastError(`Maximum file size limit is ${limitFileSize} MB`)
                  } else if (replaceUpload && clearFiles) {
                    clearFiles()
                    input.onChange([file])
                  } else if (duplicateCheck) { //case alert duplicate file
                    let newFileDup = -1
                    if(currentInput>0){
                      // get duplicate new file
                      newFileDup = currentInput.findIndex(x => x.path === file.path)
                    }    
                    // get duplicate old file                
                    let oldFileDup = oldFiles ? oldFiles.findIndex(x => x.originalFilename === file.path && !x.deleted && x.documentCode.toLowerCase()==input.name.toLowerCase()) : -1
                    if (oldFileDup < 0 && newFileDup < 0) {// no duplicate file
                      input.onChange([...currentInput, file])
                    } else {
                      props.showConfirmModal(
                        true,
                        {
                          header: 'Systems',
                          message: 'There is already a file with the same name, Would you like to replace the existing file?',
                          btnConfirmText: 'Yes',
                          btnCancelText: 'No',
                          onClickConfirm: () => {
                            if(limitFileItem>0){
                              checkCaseLimitFileItem(currentInput,file)
                            }else{
                              if (newFileDup >= 0) {
                                currentInput.splice(newFileDup, 1)
                                input.onChange([...currentInput, file])
                              } else {
                                change(`attachments[${oldFileDup}].deleted`, true)
                                input.onChange([...currentInput, file])
                              }
                            }
                          }
                        }
                      )
                    }
                  } else if(limitFileItem>0) {//case limit file item
                    checkCaseLimitFileItem(currentInput,file)
                  } else {
                    input.onChange([...currentInput, file])
                  }
                }
                reader.onabort = () => toastError('file reading was aborted')
                reader.onerror = () => toastError('file reading has failed')

                reader.readAsBinaryString(file)
              })
            }}
        >
          {({ getRootProps, getInputProps, isDragActive }) => {
            return (
              <DropzoneContainer
                {...getRootProps()}
                className={classnames('dropzone', { 'dropzone--isActive': isDragActive })}
              >
                <div className='inputContent'>
                  <input {...getInputProps()} />
                  <div className={classnames('dropArea', { error: touched && error })}>
                    <div className='textTitle'><Icon name='upload' /> Drag file to upload</div>
                    <div className='textTitle'>Or</div>
                    <div className='buttonUI'>Choose File</div>
                  </div>
                </div>
              </DropzoneContainer>
            )
          }}
        </Dropzone>:null}
        {
          input.value && input.value instanceof Array ?
            input.value.map((file, index) => {
              return (
                <FileUploadCell
                  key={file.name}
                  fileName={file.name || file.originalFilename}
                  fileSize={file.size}
                  urlPath={file.urlPath || null}
                  onClickDelete={() => {
                    var clone = [...input.value]
                    clone.splice(index, 1)
                    input.onChange([...clone])
                  }} />
              )
            }) : null
        }
        {
          showOldFile ?
            oldFiles.map((f, index) =>{
              if(f.deleted) return null
              return (
                <FileUploadCell
                  key={f.filename}
                  fileName={f.originalFilename}
                  fileSize={f.size}
                  urlPath={f.urlPath}
                  deletable={editable}
                  onClickDelete={() => {
                    removeOldFiles(index, f.id)
                  }}
                />
              )
            }) : null
        }
        {
          !input.value && oldFiles.length==0?
          <span style={{textAlign:'center'}}>No File</span>:null
        }
      </div>
    </div>
  )
}
const mapStateToProps = (state) => ({})
const mapDispatchToProps = {
  toastWarning,
  toastError,
  showConfirmModal
}

export default connect(mapStateToProps, mapDispatchToProps)(FileInput)